import { LoadingIcon } from '@/shared/ui/icon'

import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useSelectStateContext } from './SelectStateContext'

export const FetchingResultsOption: FC = ({ label }: { label?: string }) => {
  const { size } = useSelectStateContext()
  const { t } = useTranslation()
  return (
    <div className="selectw-option selectw-no-options-found selectw-option-disabled">
      <LoadingIcon size={size} />
      <span>{label ?? t('common.select.fetching')}</span>
    </div>
  )
}
FetchingResultsOption.displayName = 'SelectetchingResultsOption'
